enum FontSize {
  xxs = 8,
  xs = 12,
  s = 14,
  m = 16,
  l = 18,
  xl = 20,
  xxl = 24,
  xxxl = 28,
  xxxxl = 36,
}

export default FontSize;
